/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { DirectionalHint, Callout, Stack, Spinner } from '@fluentui/react';
import BlockUi from 'react-block-ui';
import {
  Button,
  Caption1Stronger,
  Caption1,
} from '@fluentui/react-components';

import { fetchPerformanceInsightsData } from './util/service';
import { normalizeData } from './util/util';
import {
  PERFORMANCE_INSIGHTS_TYPE,
  PERFORMANCE_INSIGHTS_POPUP_CONFIG,
  PERFORMANCE_INSIGHTS_PANEL_CONTAINER,
} from './constants/consts';
import { calloutStyles } from './style/style';
import { PerformanceInsightsIssuePanel } from './performance-insights-issue-panel';

// TODO: get type from real data
/*
const getType = (entity) => {
  const { DiagnosticsCount, RecommendationCount } = _.get(entity, 'PerformanceInsights', {});
  if (DiagnosticsCount > 0) {
    return PERFORMANCE_INSIGHTS_TYPE.ISSUE;
  } else if (RecommendationCount > 0) {
    return PERFORMANCE_INSIGHTS_TYPE.RECOMMENDATION;
  }
  return null;
};
*/

export const PerformanceInsightsToolTipCard = (props) => {
  const {
    event,
    closePerformanceInsightsPopup,
    i18n,
    newI18n,
    entity,
    serverContext,
    refreshGrid,
    scope,
  } = props;
  const [isBlocking, setIsBlocking] = useState(true);
  const [allData, setAllData] = useState(null);
  // TODO: get type from real data
  // const type = getType(entity);
  const type = PERFORMANCE_INSIGHTS_TYPE.ISSUE;
  const [subType, setSubType] = useState(null);
  const [issueOrder, setIssueOrder] = useState([]);
  const onClick = () => {
    closePerformanceInsightsPopup();
    ReactDOM.render(
      (<PerformanceInsightsIssuePanel
        entity={entity}
        newI18n={newI18n}
        allData={allData}
        refreshGrid={refreshGrid}
        scope={scope}
        issueOrder={issueOrder}
      />),
      document.querySelector(PERFORMANCE_INSIGHTS_PANEL_CONTAINER)
    );
  };
  useEffect(() => {
    fetchPerformanceInsightsData({ serverContext, entity }).then((response) => {
      let result = {};
      const { CheckpointResults } = response || {};
      if (response && !_.isEmpty(CheckpointResults)) {
        result = normalizeData({ checkpointResults: CheckpointResults, i18n, serverContext });
      }
      setAllData(result);
      setIsBlocking(false);
      const issueOrderArray = _.map(CheckpointResults, checkpointResult => checkpointResult.CheckpointKey);
      setIssueOrder(issueOrderArray);
      setSubType(_.first(issueOrderArray));
    });
  }, []);

  return (
    <div onMouseLeave={closePerformanceInsightsPopup}>
      <Callout className={`performance-insights-callout ${calloutStyles.callout}`} target={event.target} directionalHint={DirectionalHint.rightCenter} role="alert" >
        <BlockUi blocking={isBlocking} loader={<Spinner />}>
          {!isBlocking && !_.isEmpty(allData) && !_.isNull(type) && !_.isNull(subType) &&
            <React.Fragment>
              <Caption1Stronger>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].title)}</Caption1Stronger>
              <Stack tokens={{ childrenGap: 16 }}>
                <Caption1>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].description, allData[subType])}</Caption1>
                <Caption1>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].pitching)}</Caption1>
              </Stack>
              <Button appearance="primary" onClick={onClick}>
                {newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].action)}
              </Button>
            </React.Fragment>
          }
        </BlockUi>
      </Callout>
    </div>
  );
};

PerformanceInsightsToolTipCard.propTypes = {
  event: PropTypes.shape({
    target: PropTypes.shape({}).isRequired,
  }).isRequired,
  closePerformanceInsightsPopup: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  entity: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      TimeZone: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  refreshGrid: PropTypes.func.isRequired,
  scope: PropTypes.shape({}).isRequired,
};
